export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto text-center">
        <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Overview</span>
        <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
          What Is the AllChinaBuy Spreadsheet?
        </h2>
        <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-3xl mx-auto">
          Looking for an easier way to research products and sellers? The AllChinaBuy Spreadsheet brings useful product information into one searchable resource. Instead of jumping between scattered links, use the spreadsheet to discover categories, compare options and continue your research with detailed guides.
        </p>
        <div className="mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors"
          >
            Explore Spreadsheet Resources
            <i className="ri-external-link-line" />
          </a>
        </div>
      </div>
    </section>
  );
}